// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import store from './store'
// 统一基础样式
import 'normalize.css'
import './assets/css/app.css'
import './assets/css/overwrite.css'
import './assets/css/common.css'
// 组件库
import ElementUi from 'element-ui'
// 语言
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css'
// 地图
import AMap from 'vue-amap'
// 过滤器
import * as time from './filters/time'
import VueIntro from 'vue-introjs'
import 'intro.js/introjs.css'
import 'intro.js/themes/introjs-modern.css'
import 'animate.css'
// 引入echarts
import * as echarts from 'echarts'
// import echarts from 'echarts'
import 'echarts/theme/macarons.js'
import VideoPlayer from 'vue-video-player'
import 'videojs-contrib-hls'
import './utils/directives.js'
import JModal from '@/components/j-modal.vue'
import JEcharts from '@/components/echarts.vue'
Vue.component('j-modal', JModal)
Vue.component('j-echarts', JEcharts)
Vue.use(VueI18n)
const messages = {
  en: {
    ...require('./language/en.js'),
    ...elementEnLocale
  },
  zh: {
    ...require('./language/zh.js'),
    ...elementZhLocale
  }
}
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh', // 指定默认语言
  messages
})

Vue.use(ElementUi, {
  i18n: (key, value) => i18n.t(key, value)
})

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.prototype.$echarts = echarts

Object.keys(time).forEach(key => {
  Vue.filter(key, time[key])
})
Vue.use(AMap)
Vue.use(VueIntro)

AMap.initAMapApiLoader({
  // key: '587f26c5a69d5dcdf91cc5f38ddaf65b',
  key: '485c29b8ea5b6be38b7ff6f17f491f3d',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'MarkerClusterer',
    'Geocoder',
    'AMap.MassMarks',
    'AMap.Weather'
  ]
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: { App }
})

export default i18n
